import {
    address,
    contact,
    hours,
    siteConfig,
    whatsappMessages
} from '@/constants/site'

export const whatsappUrl = (message: string = whatsappMessages.general): string => {
    return `https://wa.me/${contact.whatsappNumber}?text=${encodeURIComponent(message)}`
}

// Google Maps uses the visitor's current location as the starting point when no origin is given.
export const directionsUrl = (): string => {
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address.mapsQuery)}`
}

export const mapEmbedUrl = (): string => {
    return `https://www.google.com/maps?q=${encodeURIComponent(address.mapsQuery)}&z=16&output=embed`
}

export const absoluteUrl = (path: string = '/'): string => {
    if (/^https?:\/\//.test(path)) return path
    if (path === '/') return `${siteConfig.url}/`

    return `${siteConfig.url}${path.startsWith('/') ? path : `/${path}`}`
}

// Minutes since midnight in the parlour's own time zone (India), so the
// open or closed status is right wherever the visitor is.
export const parlourMinutesNow = (date: Date = new Date()): number => {
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: hours.timeZone,
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
    }).formatToParts(date)

    const hour = Number(parts.find(part => part.type === 'hour')?.value ?? 0)
    const minute = Number(parts.find(part => part.type === 'minute')?.value ?? 0)

    return hour * 60 + minute
}

export const isParlourOpen = (date: Date = new Date()): boolean => {
    const minutes = parlourMinutesNow(date)

    return minutes >= hours.openMinute && minutes < hours.closeMinute
}
